import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { Problem } from "./components/sections/Problem";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { Pathway } from "./components/sections/Pathway";
import { Volumes } from "./components/sections/Volumes";
import { Bonuses } from "./components/sections/Bonuses";
import { CaseExample } from "./components/sections/CaseExample";
import { Audience } from "./components/sections/Audience";
import { Testimonials } from "./components/sections/Testimonials";
import { Author } from "./components/sections/Author";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-slate-900" data-id="element-0" data-mp="3iiwg8rrbto4t">
      <MetaPixel data-id="element-1" data-mp="3mkhm3t5g125i" />
      <Hero data-id="element-2" data-mp="3mjzrt22ccy08" />
      <main data-id="element-3" data-mp="3mjpyb4i388ps">
        <Problem data-id="element-4" data-mp="3mj6hxs835sdv" />
        <BeforeAfter data-id="element-5" data-mp="3rcj6k2crlz6m" />
        <Pathway data-id="element-6" data-mp="3rbzngibdp4r0" />
        <Volumes data-id="element-7" data-mp="3rdkgu4lyihna" />
        <Bonuses data-id="element-8" data-mp="3rd18nfm3z7mg" />
        <CaseExample data-id="element-9" data-mp="3relvsk63foaa" />
        <Audience data-id="element-10" data-mp="6hqffdy0fe4" />
        <Testimonials data-id="element-11" data-mp="4wv3njt0sf7" />
        <Author data-id="element-12" data-mp="5ggxfcks0yi" />
        <Offer data-id="element-13" data-mp="82jf0klzq9v" />
        <Guarantee data-id="element-14" data-mp="2zl3bdjx5744s" />
        <Faq data-id="element-15" data-mp="2zllcouynw8jk" />
        <FinalCta data-id="element-16" data-mp="2zm4ywnvchj3e" />
      </main>
      <footer className="bg-plum-950 px-4 pb-28 pt-10 text-center text-sm text-plum-200" data-id="element-17" data-mp="2zmwggus3xgao">
        <p className="font-display text-lg font-extrabold text-white" data-id="element-18" data-mp="33n6wz1dizp3s">Pediatric Feeding Therapy Blueprint™</p>
        <p className="mt-1" data-id="element-19" data-mp="38kgocmkh6au9">Organize the information. Document the priorities. Structure the plan.</p>
        <p className="mt-4 text-xs text-plum-300" data-id="element-20" data-mp="3diruonbka37q">© Pediatric Feeding Therapy Blueprint™ — Dr. Elowen Varelli</p>
      </footer>
      <PurchasePopup data-id="element-21" data-mp="sunf2d84aoj8" />
      <FloatingCta data-id="element-22" data-mp="stufbw7kszal" />
    </div>;
}